module.exports = __webpack_public_path__ + "teqbahn-assets/media/blog7.1dc86951.png";